// This file contains typings which are too generic in rome-models. For example,
// viewType is always a string, enum for the view types for a widget can be
// defined here.
export var InlineMessageCTA;
(function (InlineMessageCTA) {
    InlineMessageCTA["QUERY_CORRECTED"] = "QUERY_CORRECTED";
    InlineMessageCTA["SPELL_SUGGESTION"] = "SPELL_SUGGESTION";
})(InlineMessageCTA || (InlineMessageCTA = {}));
export var FormattedInlineMessageCTA;
(function (FormattedInlineMessageCTA) {
    FormattedInlineMessageCTA["QUERY_CORRECTED_CORRECTED"] = "QUERY_CORRECTED_corrected";
    FormattedInlineMessageCTA["QUERY_CORRECTED_ORIGINAL"] = "QUERY_CORRECTED_original";
    FormattedInlineMessageCTA["SPELL_SUGGESTION_CORRECTED"] = "SPELL_SUGGESTION_corrected";
    FormattedInlineMessageCTA["SPELL_SUGGESTION_ORIGINAL"] = "SPELL_SUGGESTION_original";
})(FormattedInlineMessageCTA || (FormattedInlineMessageCTA = {}));
